var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _path8, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNothingWasSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 143,
    viewBox: "0 0 115 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 89,
    height: 124,
    rx: 4,
    fill: "#93C4E7",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 89,
    height: 124,
    rx: 4,
    fill: "#93C4E7",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 141H87C89.2091 141 91 139.209 91 137V46.3423C91 45.3658 90.6427 44.4229 89.9956 43.6916L67.5704 18.3492C66.8112 17.4913 65.7205 17 64.5748 17H6C3.79086 17 2 18.7909 2 21V137C2 139.209 3.79086 141 6 141Z",
    fill: "#DFECF4",
    stroke: "#93C4E7",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19V40.9066C67 43.1157 68.7909 44.9066 71 44.9066H89.3333",
    stroke: "#93C4E7",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 34L23 34V39H18L18 34Z",
    stroke: "#93C4E7",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 53L23 53V58H18L18 53Z",
    stroke: "#93C4E7",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 72L23 72V77H18L18 72Z",
    stroke: "#93C4E7",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 89L23 89V94H18L18 89Z",
    stroke: "#93C4E7",
    strokeWidth: 4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-1_239_4495",
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 84,
    width: 42,
    height: 42,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 66,
    y: 84,
    width: 42,
    height: 42
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8759 124C80.655 124 79.4756 123.519 78.6061 122.645L69.3563 113.396C67.5479 111.587 67.5479 108.665 69.3563 106.856C71.1646 105.048 74.0876 105.048 75.8959 106.856L81.1591 112.119L96.5277 89.0606C97.9429 86.9333 100.81 86.3598 102.942 87.7796C105.065 89.1994 105.639 92.0667 104.224 94.194L85.7239 121.942C84.9561 123.094 83.7074 123.843 82.3338 123.977C82.1766 123.991 82.0286 124 81.8759 124Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8759 124C80.655 124 79.4756 123.519 78.6061 122.645L69.3563 113.396C67.5479 111.587 67.5479 108.665 69.3563 106.856C71.1646 105.048 74.0876 105.048 75.8959 106.856L81.1591 112.119L96.5277 89.0606C97.9429 86.9333 100.81 86.3598 102.942 87.7796C105.065 89.1994 105.639 92.0667 104.224 94.194L85.7239 121.942C84.9561 123.094 83.7074 123.843 82.3338 123.977C82.1766 123.991 82.0286 124 81.8759 124Z",
    fill: "#FFAB2B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6061 122.645L80.024 121.234L80.0203 121.231L78.6061 122.645ZM69.3563 113.396L67.9421 114.81H67.9421L69.3563 113.396ZM75.8959 106.856L77.3101 105.442L75.8959 106.856ZM81.1591 112.119L79.7449 113.533L81.4702 115.259L82.8233 113.228L81.1591 112.119ZM96.5277 89.0606L98.1919 90.1698L98.1929 90.1684L96.5277 89.0606ZM102.942 87.7796L104.054 86.1171L104.051 86.1149L102.942 87.7796ZM104.224 94.194L105.888 95.3035L105.889 95.3018L104.224 94.194ZM85.7239 121.942L84.0598 120.833L85.7239 121.942ZM82.3338 123.977L82.5096 125.969L82.5189 125.968L82.5282 125.967L82.3338 123.977ZM81.8759 122C81.1796 122 80.5128 121.726 80.024 121.234L77.1882 124.055C78.4384 125.312 80.1304 126 81.8759 126V122ZM80.0203 121.231L70.7704 111.981L67.9421 114.81L77.1919 124.059L80.0203 121.231ZM70.7704 111.981C69.7432 110.954 69.7432 109.298 70.7704 108.271L67.9421 105.442C65.3526 108.031 65.3526 112.221 67.9421 114.81L70.7704 111.981ZM70.7704 108.271C71.7977 107.243 73.4544 107.243 74.4817 108.271L77.3101 105.442C74.7207 102.853 70.5315 102.853 67.9421 105.442L70.7704 108.271ZM74.4817 108.271L79.7449 113.533L82.5733 110.705L77.3101 105.442L74.4817 108.271ZM82.8233 113.228L98.1919 90.1698L94.8635 87.9514L79.4949 111.01L82.8233 113.228ZM98.1929 90.1684C98.9941 88.964 100.619 88.6349 101.834 89.4443L104.051 86.1149C101.002 84.0847 96.8918 84.9026 94.8625 87.9529L98.1929 90.1684ZM101.831 89.442C103.037 90.249 103.363 91.8772 102.558 93.0862L105.889 95.3018C107.915 92.2562 107.094 88.1498 104.054 86.1171L101.831 89.442ZM102.56 93.0846L84.0598 120.833L87.388 123.051L105.888 95.3035L102.56 93.0846ZM84.0598 120.833C83.6242 121.486 82.9143 121.911 82.1395 121.986L82.5282 125.967C84.5005 125.775 86.2881 124.701 87.388 123.051L84.0598 120.833ZM82.158 121.985C82.0317 121.996 81.9475 122 81.8759 122V126C82.1096 126 82.3215 125.986 82.5096 125.969L82.158 121.985Z",
    fill: "white",
    mask: "url(#path-9-outside-1_239_4495)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 34,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#93C4E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 53,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#93C4E7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 72,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#93C4E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 89,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#93C4E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingWasSelected);
export default __webpack_public_path__ + "static/media/NothingWasSelected.afc03e6f.svg";
export { ForwardRef as ReactComponent };